
<!-- <ng-container *ngFor = "let item of items"> -->
<!-- {{item |json}} -->
    <div class="content">
    <!-- <h3>{{item.headings[0]}}</h3> -->
   

        <div class="card-container">
            
            <div class="card" *ngFor="let location of items">
                <div class="card-title"> 
                    <h5>{{location.name }}</h5>
                    <!-- {{location |json}} -->
                </div>
                <div class="card-details" *ngFor = "let contact of location.data">
                    <p>{{ contact }}</p>
                    <!-- <p *ngIf="location.callCenter">{{ location.callCenter }}</p>
                    <p *ngIf="location.mainLine">{{ location.mainLine }}</p>
                    <p *ngIf="location.fax">{{ location.fax }}</p> -->
                    <!-- <p *ngIf="location.tollFree">{{ location.tollFree }}</p>
                    <p *ngIf="location.callCenter">{{ location.callCenter }}</p>
                    <p *ngIf="location.mainLine">{{ location.mainLine }}</p>
                    <p *ngIf="location.fax">{{ location.fax }}</p> -->
                </div>
            </div>
        </div>
</div>
<!-- </ng-container> -->
